import { Helmet } from 'components/helmet';

const baseGlobalStyles = /*css*/ `
  html, body {
    font-synthesis-weight: none;
    overscroll-behavior-x: none;
  }
  #root, body {
    display: flex;
  }
  #root, body, html {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    min-height: 100%;
    min-height: 100dvh; /* Use dvh units if the browser supports it */ 
  }
  #root {
    flex-shrink: 0;
    flex-grow: 1;
  }
  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }
  body {
    overflow-x: hidden !important;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -ms-overflow-style: scrollbar;
  }
`;

export const GlobalStylesheet = () => (
  <Helmet>
    <style id="baseGlobalStyles">{baseGlobalStyles}</style>
  </Helmet>
);
